/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PinPostRequest as BackendCoreApiModelsAppPostPinPostRequest } from '../models/Backend/Core/Api/Models/App/Post/pin-post-request';
import { PostCollectionResponse as BackendCoreApiModelsAppPostPostCollectionResponse } from '../models/Backend/Core/Api/Models/App/Post/post-collection-response';
import { RemovePostRequest as BackendCoreApiModelsAppPostRemovePostRequest } from '../models/Backend/Core/Api/Models/App/Post/remove-post-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class PostBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createPost
   */
  static readonly CreatePostPath = '/api/post/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPost$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createPost$Plain$Response(params?: {
    body?: {

/**
 * Cím
 */
'Title'?: string;

/**
 * Tartalom
 */
'Content'?: string;

/**
 * Érvényesség kezdete
 */
'ValidFrom'?: string;

/**
 * Érvényesség vége
 */
'ValidUntil'?: string;

/**
 * Kitűzve
 */
'IsPinned'?: boolean;

/**
 * File
 */
'File'?: Blob;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.CreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPost$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createPost$Plain(params?: {
    body?: {

/**
 * Cím
 */
'Title'?: string;

/**
 * Tartalom
 */
'Content'?: string;

/**
 * Érvényesség kezdete
 */
'ValidFrom'?: string;

/**
 * Érvényesség vége
 */
'ValidUntil'?: string;

/**
 * Kitűzve
 */
'IsPinned'?: boolean;

/**
 * File
 */
'File'?: Blob;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createPost$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createPost$Json$Response(params?: {
    body?: {

/**
 * Cím
 */
'Title'?: string;

/**
 * Tartalom
 */
'Content'?: string;

/**
 * Érvényesség kezdete
 */
'ValidFrom'?: string;

/**
 * Érvényesség vége
 */
'ValidUntil'?: string;

/**
 * Kitűzve
 */
'IsPinned'?: boolean;

/**
 * File
 */
'File'?: Blob;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.CreatePostPath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createPost$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  createPost$Json(params?: {
    body?: {

/**
 * Cím
 */
'Title'?: string;

/**
 * Tartalom
 */
'Content'?: string;

/**
 * Érvényesség kezdete
 */
'ValidFrom'?: string;

/**
 * Érvényesség vége
 */
'ValidUntil'?: string;

/**
 * Kitűzve
 */
'IsPinned'?: boolean;

/**
 * File
 */
'File'?: Blob;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation deletePost
   */
  static readonly DeletePostPath = '/api/post/delete';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppPostRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.DeletePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deletePost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePost$Plain(params?: {
    body?: BackendCoreApiModelsAppPostRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.deletePost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deletePost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppPostRemovePostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.DeletePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deletePost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  deletePost$Json(params?: {
    body?: BackendCoreApiModelsAppPostRemovePostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.deletePost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getPosts
   */
  static readonly GetPostsPath = '/api/post/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPosts$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosts$Plain$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.GetPostsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPosts$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosts$Plain(params?: {
  }): Observable<BackendCoreApiModelsAppPostPostCollectionResponse> {

    return this.getPosts$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppPostPostCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPosts$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosts$Json$Response(params?: {
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.GetPostsPath, 'post');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getPosts$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPosts$Json(params?: {
  }): Observable<BackendCoreApiModelsAppPostPostCollectionResponse> {

    return this.getPosts$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppPostPostCollectionResponse>) => r.body as BackendCoreApiModelsAppPostPostCollectionResponse)
    );
  }

  /**
   * Path part for operation pinPost
   */
  static readonly PinPostPath = '/api/post/pin-post';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinPost$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppPostPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.PinPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinPost$Plain(params?: {
    body?: BackendCoreApiModelsAppPostPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinPost$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `pinPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinPost$Json$Response(params?: {
    body?: BackendCoreApiModelsAppPostPinPostRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, PostBackendService.PinPostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `pinPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  pinPost$Json(params?: {
    body?: BackendCoreApiModelsAppPostPinPostRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.pinPost$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
